import React, {ReactNode, useState, useMemo, useRef, useEffect } from 'react';
import {Popover} from "antd";
import {
    CustomWrapper,
    DesktopNewPopoverWrapper,
} from "./styles";
import SelectSearches from "./SelectSearches";
import {useStore} from "../../store/global/appStore";
import { ReactComponent as FlightIcon } from "../../assets/images/flight-takeoff.svg";
import { ReactComponent as FlightLandIcon } from "../../assets/images/flight-land.svg";

type Props = {
    label: string,
    placeholder?: string,
    defaultValue?: string,
    onChange?: (value: any) => void;
    suffixIcon?: ReactNode,
    value?: string | number,
    renderIcon: () => ReactNode
    tripType: string,
    limitSuggestionHeight?: boolean,
    mode: string,
    allowMultipleDestinations?: boolean,
    disabled?: boolean,
    onAddMultipleDestinations?: () => void,
}

const DesktopSelector = ({ label, tripType, value, onChange, renderIcon, limitSuggestionHeight, mode, allowMultipleDestinations, disabled, onAddMultipleDestinations }: Props) => {
    const [isOpen, setIsOpen] = useState(false);
    const [text, setText] = useState("");
    const [searchText, setSearchText] = useState("");
    const { roadRoutes, airports} = useStore();
    const [popOverHeight, setPopOverHeight] = useState(478);

    const displayValue = useMemo(() => {
        if(tripType === "road"){
            return roadRoutes.find((option) => option.TerminalId.toString() === value)?.TerminalName;
        }

        const airport = airports.find((option) => option.Code === value);
        if(airport){
            return `${airport.Code}, ${airport.StateName}`;
        }

        if(value) {
            return value.toString();
        }

        return '';
    }, [value, airports, roadRoutes]);

    const handleSelect = (val: any) => {
        onChange(val);
        setIsOpen(false);

        if(val === value) {
            setText(displayValue);
        }
    }


    useEffect(() => {
        if(displayValue) {
            setText(displayValue);
        }
    }, [displayValue]);

    const desktopContent = (
        <div>
            {
                tripType === 'road' ? (
                    null
                ) : (
                    <SelectSearches
                        onSelect={handleSelect}
                        searchText={searchText}
                        height={popOverHeight}
                            limitSuggestionHeight={limitSuggestionHeight}
                            mode={mode}
                            allowMultipleDestinations={allowMultipleDestinations}
                            disabled={disabled}
                            onAddMultipleDestinations={onAddMultipleDestinations}
                            setSearchText={setSearchText}
                            setIsOpen={setIsOpen}
                    />
                )
            }
        </div>
    );

    const anchorRef = useRef<HTMLDivElement>(null);

    return (
        <div>
            <DesktopNewPopoverWrapper ref={anchorRef}>
                <Popover
                    placement="bottomLeft"
                    content={desktopContent}
                    overlayStyle={{ minWidth: '450px', width: 450 }}
                    open={isOpen}
                    trigger="click"
                    onOpenChange={(open) => setIsOpen(open)}
                    overlayClassName="custom-popover"
                    getPopupContainer={() => document.body}
                >
                    <CustomWrapper>

                        {mode === 'from' ? <FlightIcon /> : <FlightLandIcon />} { displayValue}
                    </CustomWrapper>
                </Popover>
            </DesktopNewPopoverWrapper>
        </div>
    );
};

DesktopSelector.defaultProps = {
    placeholder: undefined,
    defaultValue: undefined,
    suffixIcon: undefined,
    value: undefined,
    onChange: undefined,
};

export default DesktopSelector;
